/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_End_StartInputs */

const en_us2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End it and start new`)
};

const pt_br2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar e começar novo`)
};

const es_419_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminarlo y empezar otro`)
};

const pt_pt2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar e começar novo`)
};

const fr_fr2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La terminer et en commencer une`)
};

const de_de2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden und neu starten`)
};

const it_it2_workout_open_end_start = /** @type {(inputs: Workout_Open_End_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminalo e iniziane uno nuovo`)
};

/**
* | output |
* | --- |
* | "End it and start new" |
*
* @param {Workout_Open_End_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_end_start = /** @type {((inputs?: Workout_Open_End_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_End_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_end_start(inputs)
	if (locale === "es-419") return es_419_workout_open_end_start(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_end_start(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_end_start(inputs)
	if (locale === "de-DE") return de_de2_workout_open_end_start(inputs)
	if (locale === "it-IT") return it_it2_workout_open_end_start(inputs)
	return en_us2_workout_open_end_start(inputs)
});
export { workout_open_end_start as "workout.open_end_start" }